import { Subscribable } from '@benzinga/subscribable';
import { VerticalsRestful } from './restful';
import { VerticalsRequestEvent } from './manager';
import { Session } from '@benzinga/session';

export class VerticalRequest extends Subscribable<VerticalsRequestEvent> {
  private restful: VerticalsRestful;

  constructor(session: Session) {
    super();
    this.restful = new VerticalsRestful(session);
  }
  getVerticals = async () => {
    const verticals = await this.restful.getVerticals();
    if (verticals.err) {
      this.dispatch({
        error: verticals.err,
        type: 'verticals:error_verticals',
      });
      return { err: verticals.err };
    }
    return { ok: verticals.ok };
  };
}
